import { useQuery } from "@apollo/client";

import {
  IntegrationServiceType,
  ListIntegrationsQuery,
  ListIntegrationsQueryVariables,
} from "~frontend/__generated__/graphql";
import { LIST_INTEGRATIONS } from "~frontend/graphql/integration";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

// If specific service type provided, will return only that type of integration
export const useIntegrations = (
  {
    service,
    subaccountId,
  }: { service?: IntegrationServiceType; subaccountId?: string } = {
    service: undefined,
    subaccountId: undefined,
  }
): {
  loading: boolean;
  error: Error | undefined;
  integrations: ListIntegrationsQuery["listIntegrations"];
  hasIntegration: boolean;
} => {
  const subaccountInfo = useSubaccount();

  const { data, loading, error } = useQuery<
    ListIntegrationsQuery,
    ListIntegrationsQueryVariables
  >(LIST_INTEGRATIONS, {
    variables: {
      input: {
        services: service ? [service] : null,
        subaccountId: subaccountId || subaccountInfo!.subaccount.id,
      },
    },
  });

  return {
    loading,
    error,
    integrations: data?.listIntegrations || [],
    hasIntegration: !!data?.listIntegrations?.length,
  };
};
